import { useEffect } from 'react';
import { type HotjarWindow } from './types';

const HOTJAR_BASE_URL = 'https://static.hotjar.com/c/hotjar-';
const HOTJAR_SUFFIX = '.js?sv=';
const HOTJAR_VERSION = 6;

export const HotjarScript = (): React.ReactElement => {
  useEffect(() => {
    const hotjarId = import.meta.env.VITE_HOTJAR_ID;

    if (import.meta.env.MODE !== 'production' || !hotjarId || typeof window === 'undefined') {
      return;
    }

    (function (
      h: HotjarWindow,
      o: Document,
      t: string,
      j: string,
      a?: HTMLElement,
      r?: HTMLScriptElement
    ): void {
      h.hj =
        h.hj ||
        function (...args: unknown[]): void {
          (h.hj.q = h.hj.q || []).push(args);
        };

      h._hjSettings = { hjid: Number(hotjarId), hjsv: HOTJAR_VERSION };
      a = o.getElementsByTagName('head')[0];
      r = o.createElement('script');
      r.async = true;
      r.src = `${t}${h._hjSettings.hjid}${j}${h._hjSettings.hjsv}`;
      a.appendChild(r);
    })(window as unknown as HotjarWindow, document, HOTJAR_BASE_URL, HOTJAR_SUFFIX);
  }, []);

  return <></>;
};
